<template>
  <div class="view">
    <div>
      <h1 class="header">
        {{ header }}
      </h1>
    </div>
    <div>
      <slot>

      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewLayout",
  props: {
    header: String
  }
}
</script>

<style scoped>
.header {
  text-align: center;
  font-size: 50px;
  margin-bottom: 20px;
}
</style>